import * as Sentry from "@sentry/browser";
import { Macros } from "./Macros";
import API from "../lib/TimeEditAPI";

export class PrimaryFieldManager {
    fields: any;
    fireEvent: any;
    primaryFieldOptions: Record<number, number[]>;
    _loadCallbacks: Record<number, (() => void)[]>;

    constructor(registerMacro, fireEvent) {
        this.fields = {};
        this.primaryFieldOptions = {};
        this._loadCallbacks = {};
        this.fireEvent = fireEvent;
        // This macro is deregistered by App.jsx when unmounting
        registerMacro(`primaryFieldManager`, {
            events: [Macros.Event.PRIMARY_FIELD_CHANGED],
            actions: [
                {
                    key: Macros.Action.REFRESH,
                    action: (typeId) => {
                        this.getPrimaryField(typeId);
                    },
                },
            ],
        });
    }

    setPrimaryField(typeId, fieldId) {
        if (this.fields[typeId] === fieldId) {
            return;
        }
        this.fields[typeId] = fieldId;
        API.setPrimaryField(typeId, fieldId, () => {
            this.fireEvent("primaryFieldManager", Macros.Event.PRIMARY_FIELD_CHANGED, typeId);
        });
    }

    getPrimaryField(typeId) {
        API.getPrimaryFields(typeId, (result) => this.storePrimaryFields(typeId, result));
    }

    ensurePrimaryField(typeId: number, fieldId: number) {
        const options = this.primaryFieldOptions[typeId];
        if (options === undefined) {
            this.loadPrimaryFields(typeId, () => this.ensurePrimaryField(typeId, fieldId));
            return;
        }
        if (this.fields[typeId] === fieldId) {
            return;
        }
        if (!options.includes(fieldId)) {
            Sentry.captureMessage("Object list names objects by a field that cannot be primary", {
                level: "warning",
                extra: { typeId, fieldId, primaryFields: options },
            });
            return;
        }
        this.setPrimaryField(typeId, fieldId);
    }

    loadPrimaryFields(typeId: number, callback: () => void) {
        const waiting = this._loadCallbacks[typeId];
        if (waiting) {
            waiting.push(callback);
            return;
        }
        this._loadCallbacks[typeId] = [callback];
        API.getPrimaryFields(typeId, (result) => {
            const callbacks = this._loadCallbacks[typeId];
            delete this._loadCallbacks[typeId];
            this.storePrimaryFields(typeId, result);
            callbacks.forEach((cb) => cb());
        });
    }

    storePrimaryFields(typeId: number, result: { id: number }[]) {
        this.primaryFieldOptions[typeId] = result.map((field) => field.id);
        this.fields[typeId] = result[0]?.id ?? null;
    }
}
